<div *ngIf="(features | json) != '{}'">
  <div>
    <h2 style="margin-bottom: 5px;">{{'newOrder.trialLens.tabs.calculation.title' | translate}}</h2>
  </div>

  <div class="parameters-box">
    <div class="d-flex">
      <div class="label">{{"newOrder.trialLens.backside" | translate}}:</div>
      <div class="value">{{this.data?.backSide?.name}}</div>
    </div>
    <div class="d-flex">
      <div class="label">{{"newOrder.trialLens.material" | translate}}:</div>
      <div class="value">{{this.data?.material?.name}}</div>
    </div>
  </div>

  <div>
    <form [formGroup]="form">
      <div class="feature-box">
        <label *ngIf="isEnabled('RadiusBasecurve')" [matTooltip]="getHintByName('RadiusBasecurve') | async" matTooltipPosition="above">{{getTranslation('RadiusBasecurve') | async}}
          <input disabled type="text" class="form-control range-feature" [name]="RadiusBasecurve" (blur)="setValueWithFormat('RadiusBasecurve')" [formControlName]="'RadiusBasecurve'">
        </label>
        <label *ngIf="isEnabled('RadiusBaseCurve2')" [matTooltip]="getHintByName('RadiusBaseCurve2') | async" matTooltipPosition="above">{{getTranslation('RadiusBaseCurve2') | async}}
          <input disabled type="text" class="form-control range-feature" [name]="RadiusBaseCurve2" (blur)="setValueWithFormat('RadiusBaseCurve2')" [formControlName]="'RadiusBaseCurve2'">
        </label>
        <label *ngIf="isEnabled('Sphere')" [matTooltip]="getHintByName('Sphere') | async" matTooltipPosition="above">{{getTranslation('Sphere') | async}}
          <input disabled type="text" class="form-control range-feature" [name]="Sphere" (blur)="setValueWithFormat('Sphere')" [formControlName]="'Sphere'">
        </label>
        <label *ngIf="isEnabled('DioptreSteep')" [matTooltip]="getHintByName('DioptreSteep') | async" matTooltipPosition="above">{{getTranslation('DioptreSteep') | async}}
          <input disabled type="text" class="form-control range-feature" [name]="DioptreSteep" (blur)="setValueWithFormat('DioptreSteep')" [formControlName]="'DioptreSteep'">
        </label>
        <label *ngIf="isEnabled('AxisComplete')" [matTooltip]="getHintByName('AxisComplete') | async" matTooltipPosition="above">{{getTranslation('AxisComplete') | async}}
          <input disabled type="text" class="form-control range-feature" [name]="AxisComplete" (blur)="setValueWithFormat('AxisComplete')" [formControlName]="'AxisComplete'">
        </label>
        <label *ngIf="isEnabled('Cylinder')" [matTooltip]="getHintByName('Cylinder') | async" matTooltipPosition="above">{{getTranslation('Cylinder') | async}}
          <input disabled type="text" class="form-control range-feature" [name]="Cylinder" (blur)="setValueWithFormat('Cylinder')" [formControlName]="'Cylinder'">
        </label>
        <label *ngIf="isEnabled('AxisCylinder')" [matTooltip]="getHintByName('AxisCylinder') | async" matTooltipPosition="above">{{getTranslation('AxisCylinder') | async}}
          <input disabled type="text" class="form-control range-feature" [name]="AxisCylinder" (blur)="setValueWithFormat('AxisCylinder')" [formControlName]="'AxisCylinder'">
        </label>
      </div>

      <div *ngIf="additionalOptions">
        <h2>{{"newOrder.hechtProposal.response.additionalOptions" | translate}}</h2>
        <mat-radio-group formControlName="additionalOptions">
          <mat-radio-button value="prisma" class="mat-radio-button-first">Prisma</mat-radio-button>
          <mat-radio-button value="none">{{"newOrder.hechtProposal.response.none" | translate}}</mat-radio-button>
        </mat-radio-group>
        <div *ngIf="form.get('additionalOptions').value === 'prisma'">
          <label [matTooltip]="'common.hints.PrismType' | translate" matTooltipPosition="above" style="margin-right: 20px;">{{"common.features.PrismType" | translate}}
            <mat-select formControlName="PrismType" class="form-control" style="width: 120px;">
              <mat-option *ngFor="let currentValue of childPrismType" [value]="currentValue">
                {{currentValue}}
              </mat-option>
            </mat-select>
            <!--<input type="text" class="form-control" style="width: 120px;"
                   *ngFor="let currentValue of childPrismType" [disabled]="true" value="{{currentValue}}">-->
          </label>
          <label [matTooltip]="'common.hints.Prism' | translate" matTooltipPosition="above">{{"common.features.Prism" | translate}}
            <input type="text" class="form-control" formControlName="Prism" style="width: 100px;" (blur)="setValueWithFormat('Prism')">
          </label>
        </div>
      </div>
    </form>
  </div>

</div>
